import $axios from '~/plugins/axios';
import { buildModule } from '../utils';
import {
	Api,
	UploadData,
	UploadDataApproveOrDenyRequest,
	UploadDataBulkApproveOrDenyRequest,
} from '~/api';
import { createDict, Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		storedUploadData: {} as Dict<UploadData>,
	})
	.withGetters({
		byId: state => (id: number): UploadData | null => (
			state.storedUploadData[id] ?? null
		),
	})
	.withMutations({
		STORE_UPLOAD_DATA (state, uploadData: UploadData[]) {
			state.storedUploadData = {
				...state.storedUploadData,
				...createDict(uploadData, ({ id }) => id),
			};
		},
	})
	.withActions({
		async approve ({ commit }, { id, ...payload }: { id: number } & UploadDataApproveOrDenyRequest) {
			const { data } = await api.post(`/upload-data/${ id }/approve`, payload);
			commit('STORE_UPLOAD_DATA', [ data.payload ]);
			return data.payload;
		},

		async bulkApprove ({ commit }, { ids, comment }: UploadDataBulkApproveOrDenyRequest) {
			const { data } = await api.post('/upload-data/bulk/approve', { ids, comment });
			commit('STORE_UPLOAD_DATA', data.payload);
			return data.payload;
		},

		async deny ({ commit }, { id, ...payload }: { id: number } & UploadDataApproveOrDenyRequest) {
			const { data } = await api.post(`/upload-data/${ id }/deny`, payload);
			commit('STORE_UPLOAD_DATA', [ data.payload ]);
			return data.payload;
		},

		async bulkDeny ({ commit }, { ids, comment }: UploadDataBulkApproveOrDenyRequest) {
			const { data } = await api.post('/upload-data/bulk/deny', { ids, comment });
			commit('STORE_UPLOAD_DATA', data.payload);
			return data.payload;
		},
	});

